type SearchParameters = Record<string, string | string[] | undefined>;

export function shouldOpenIntegrationModal(
    parameters: SearchParameters,
    integration: string,
): boolean {
    const requestedIntegration = parameters.integration;

    return (
        typeof requestedIntegration === "string" &&
        requestedIntegration.toLowerCase() === integration.toLowerCase()
    );
}
